<div>
  <label>
    <ng-content select="[label]"></ng-content>
  </label>
  <div [class.emphasized]="emphasized">
    <ng-content select="[value]"></ng-content>
  </div>
</div>
